import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Setor } from 'src/app/models/setor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { SetorService } from 'src/app/services/setor.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { EtapaOcorrencia } from 'src/app/models/etapa-ocorrencia';
import { OcorrenciaService } from 'src/app/services/ocorrencia.service';
import { OcorrenciaTipoService } from 'src/app/services/ocorrencia-tipo.service';
import { OcorrenciaTipo } from 'src/app/models/ocorrencia-tipo';
import { TemplateEmailService } from 'src/app/services/template-email.service';
import { TemplateEmail } from 'src/app/models/template-email';

@Component({
  selector: 'app-cadastrar-etapa-ocorrencia-modal',
  templateUrl: './cadastrar-etapa-ocorrencia-modal.component.html',
  styleUrls: ['./cadastrar-etapa-ocorrencia-modal.component.scss']
})
export class CadastrarEtapaOcorrenciaModalComponent implements OnInit {
  idEtapaOcorrencia: number;
  etapaOcorrencia: EtapaOcorrencia = new EtapaOcorrencia();
  setores: Setor[] = [];
  setorSelecionado;
  tiposOcorrencia: OcorrenciaTipo[] = [];
  tipoOcorrenciaSelecionado;
  templates: TemplateEmail[] = [];
  situacao = [{ id: 1, descricao: 'Ativo' }, { id: 0, descricao: 'Inativo' }];
  situacaoSelecionada: number = 1;
  podeEnviarEmail = [{ id: 1, descricao: 'Sim' }, { id: 0, descricao: 'Não' }];
  podeEnviarEmailSelecionado = 0;
  public config: PerfectScrollbarConfigInterface = {};
  editando: boolean;
  minDate: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<CadastrarEtapaOcorrenciaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private ocorrenciaService: OcorrenciaService,
    private setorService: SetorService,
    private ocorrenciaTipoService: OcorrenciaTipoService,
    private templateEmailService: TemplateEmailService
  ) {
    this.idEtapaOcorrencia = data.idEtapa;

    if (!this.idEtapaOcorrencia) {
      this.setorSelecionado = data.idSetor;
      this.tipoOcorrenciaSelecionado = data.idTipo;
    }
  }

  ngOnInit(): void {
    this.buscarSetores();
    this.buscarTemplates();

    if (this.idEtapaOcorrencia) {
      this.editando = true;
      this.buscarEtapa();
    } else {
      this.etapaOcorrencia = new EtapaOcorrencia();

      if (this.setorSelecionado !== null && this.setorSelecionado !== undefined) {
        this.buscarTipoOcorrencia(false);
      }
    }
  }

  recebeDados() {
    this.etapaOcorrencia.ativo = this.situacaoSelecionada;
    this.etapaOcorrencia.idSetor = this.setorSelecionado;
    this.etapaOcorrencia.nomeSetor = this.setores.find(setor => setor.id === this.setorSelecionado).descricao;
    this.etapaOcorrencia.idTipoOcorrencia = this.tipoOcorrenciaSelecionado;
    this.etapaOcorrencia.nomeTipo = this.tiposOcorrencia.find(tipo => tipo.id === this.tipoOcorrenciaSelecionado).descricao;
    this.etapaOcorrencia.enviarEmail = this.podeEnviarEmailSelecionado === 1;
  }

  salvar() {
    this.recebeDados();

    this.carregandoService.mostra('salvarEtapa');
    this.ocorrenciaService.salvarEtapa(this.etapaOcorrencia).subscribe((retorno) => {
      this.notificacaoService.sucesso('Setor salvo com sucesso!!!');
      this.carregandoService.esconde('salvarEtapa');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarEtapa');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarEtapa() {
    this.carregandoService.mostra('buscarEtapa');

    this.ocorrenciaService.consultarPorIdEtapa(this.idEtapaOcorrencia).subscribe((data: any) => {
      this.etapaOcorrencia = data;

      this.setorSelecionado = this.etapaOcorrencia.idSetor;
      this.buscarTipoOcorrencia();
      this.tipoOcorrenciaSelecionado = this.etapaOcorrencia.idTipoOcorrencia;
      this.podeEnviarEmailSelecionado = this.etapaOcorrencia.enviarEmail ? 1 : 0;

      this.carregandoService.esconde('buscarEtapa');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapa');
      this.notificacaoService.erro(erro);
    });
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');
    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTipoOcorrencia(flag = true) {
    if (flag)
      this.tipoOcorrenciaSelecionado = null;

    this.carregandoService.mostra('tipoOcorrencia');
    this.ocorrenciaTipoService.consultarPorIdSetor(this.setorSelecionado).subscribe((data: any) => {
      this.tiposOcorrencia = data;
      this.carregandoService.esconde('tipoOcorrencia');
    }, (erro) => {
      this.carregandoService.esconde('tipoOcorrencia');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTemplates() {
    this.carregandoService.mostra('buscarTemplates');

    this.templateEmailService.consultarTemplates().subscribe(dados => {
      this.templates = dados;
      this.carregandoService.esconde('buscarTemplates');
    }, (erro) => {
      this.carregandoService.esconde('buscarTemplates');
      this.notificacaoService.erro(erro);
    });
  }

  onChangeSetor() {
    this.buscarTipoOcorrencia();
  }

  validar() {
    return this.etapaOcorrencia.descricao !== null && this.etapaOcorrencia.descricao !== undefined && this.tipoOcorrenciaSelecionado !== null && this.tipoOcorrenciaSelecionado !== undefined && (this.podeEnviarEmailSelecionado ? this.etapaOcorrencia.idTemplateEmail !== null && this.etapaOcorrencia.idTemplateEmail !== undefined : true);
  }
}
